module.exports = __webpack_public_path__ + "img/verified.97f82926.svg";